import * as React from "react";
import styled from "styled-components";
import { Link, IfPermitted, Spinner } from "components/common";
import { Alert, Col, Row } from "components/bootstrap";
import AppConfig from "util/AppConfig";
import { LICENSE_TYPES, LICENSE_SUBJECTS } from "license/constants";
import LicensesRoutes from "license/Routes";
import useLicenseValidityForSubject from "./hooks/useLicenseValidityForSubject";
const isCloud = AppConfig.isCloud();
const StyledP = styled.p`
  white-space: break-spaces;
`;
export const Warning = ({
  title = null,
  text = null,
  bsStyle = "info",
  licenseSubject = LICENSE_SUBJECTS.enterprise,
  featureName
}) => {
  const licenseType = LICENSE_TYPES[licenseSubject];
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle, title: title != null ? title : `${licenseType} license required` }, /* @__PURE__ */ React.createElement(StyledP, null, text != null ? text : `A valid ${licenseType} license is required to use ${featureName != null ? featureName : "this"} functionality.`), isCloud ? /* @__PURE__ */ React.createElement(React.Fragment, null, "Contact your Graylog account manager.") : /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "licenses:create" }, /* @__PURE__ */ React.createElement("p", null, "See ", /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }, "Licenses page"), " for details.")));
};
export const InvalidLicenseWarning = ({
  licenseSubject = LICENSE_SUBJECTS.enterprise,
  featureName,
  displayWarningContainer,
  title = null,
  text = null,
  bsStyle = "info"
}) => {
  if (displayWarningContainer) {
    return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      Warning,
      {
        licenseSubject,
        featureName,
        title,
        text,
        bsStyle
      }
    )));
  }
  return /* @__PURE__ */ React.createElement(Warning, { licenseSubject, featureName, title, text, bsStyle });
};
const LicenseCheck = ({
  children = void 0,
  featureName = null,
  licenseSubject = LICENSE_SUBJECTS.enterprise,
  displayLicenseWarning = true,
  displayWarningContainer = false,
  hideChildren = false,
  title = null,
  text = null,
  bsStyle = "info"
}) => {
  const {
    data: { valid },
    isInitialLoading: isLoading
  } = useLicenseValidityForSubject(licenseSubject);
  const resultChildren = typeof children === "function" ? children({ licenseIsValid: valid }) : children;
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !valid && displayLicenseWarning && /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      licenseSubject,
      featureName,
      displayWarningContainer,
      title,
      text,
      bsStyle
    }
  ), valid && resultChildren, !valid && !hideChildren && resultChildren);
};
export default LicenseCheck;
